<!-- 头部 -->
<template>
  <div class="cgh-view">
    <div class="cgh-head">
      <div class="logo" v-if="type != 1">
        <span class="back" @click="back">
          <Icon name="arrow-left" />
        </span>
      </div>
      <div class="search-content">
        <span class="type">
          <span>{{title}}</span>
        </span>
      </div>
      <div class="cgh-right-con"  v-if="type == 3 || type == 4" @click="onRight()">
        <Icon :name="rightIcon" />
      </div>
      <div class="cgh-middle-con"  v-if="type == 4" @click="onMiddel()">
        <Icon name="shopping-cart-o" />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  name: "cghhead",
  props: {
    title: {
      type: String,
      defaul: "详情" // 标题
    },
    type: {
      type: Number,
      defaul: 0 // 0有返回按钮 1:没有返回按钮 3显示右边按钮 4显示中间右边按钮 
    },
    rightIcon: {
      type: String,
      default: 'ellipsis'
    },
    isBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    back() {
      if (!this.isBack) {
        this.$emit('back');
      } else { // 返回
        this.$router.back();
      }
     
    },
    onRight () {
      this.$emit('onRight');
    },
    onMiddel () {
      this.$router.push('/cart');
    }
  },
  components: {
    Icon
  }
};
</script>
<style scoped lang='scss'>
@import "@/assets/style/minxi.scss";
.cgh-view {
  .cgh-head {
    height: 48px;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    text-align: center;
    border-bottom: 1px solid #cccccc;
    color: black;
    background: white;
    z-index: 9;
    line-height: 48px;
    .logo {
      position: fixed;
      left: 10px;
      z-index: 10;
      Icon {
        font-size: 40px;
        color: white;
      }
    }
    .search-content {
      font-size: 14px;
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }

    .cgh-right-con {
      position: fixed;
      right: 15px;
      top: 2px;
      font-size: 22px;
      z-index: 10;
    }
    .cgh-middle-con {
      position: fixed;
      right: 48px;
      top: 2px;
      font-size: 18px;
      z-index: 10;
  }
  }
}
</style>